module.exports = __webpack_public_path__ + "static/img/10012 (1).36e2a40.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10012 (1).webp
// module id = Zxi7
// module chunks = 14